import React, { useRef, useState, useContext, useEffect, createRef } from 'react';
import InsertEmoticonIcon from '@mui/icons-material/InsertEmoticon';
import { OnTheMenuDataContext } from '../../../context-api/OnTheMenuDataProvider';
import { CheckoutDataContext } from '../../../context-api/CheckoutDataProvider';
import { isMobile, isDesktop, isIpad } from '../../../global/ScreenSizeHelper';
import TextTransformation from '../../../global/textTransformation';
import PageBase from '../../../composed/pagebase/pagebase';
import MenuTabs from '../../../atomic/MenuTabs/MenuTabs';
import {
  getUrlParams,
  getUrlPath,
  getUrlFullPath,
  removeParamFromUrl,
} from '../../../global/getUrl';
import Storetitle from '../../../composed/storetitle/storetitle';
import './RestaurantMenu.scss';
import { LoginDataContext } from '../../../context-api/LoginDataProvider';
import ProductCard from '../../../composed/ProductCard/ProductCard';
import AtomicButton from '../../../atomic/button/AtomicButton';
import VerticalProductStepper from './VerticalProductSteppers';
import ProductVerticalStepper from './VerticalProductSteppers';

const RestaurantMenuIpad = () => {
  const {
    productsData = {},
    sortedKitchenData,
    cartItems,
    setCartItems,
    getMealOffering,
  } = useContext(OnTheMenuDataContext);
  const { loginData, onLogin, isLoggedIn, customerInfoData, onLogout, ButtonSwitchSubscription } =
    useContext(LoginDataContext);
  const { loading, data, success, errorMessage } = customerInfoData;
  const custInfoData = data?.data || [];
  const {
    regularMenuAvailable,
    subscriptionMenuAvailable,
    freeSubscriptionDelivery,
    deliverySubscription_fee,
    deliveryPayAsYouGo_fee,
  } = sortedKitchenData;

  const { storename: urlStoreName } = getUrlParams();
  const [activeTab, setActiveTab] = useState('');
  const IsCartItems = Array.isArray(cartItems) && cartItems.length > 0;
  const [mealType, setMealType] = useState('Menu');
  const [menuTabNames, setMenuTabNames] = useState({ Menu: [], 'Combo Menu': [] });
  // const mealTypeButtons = [{ label: 'Menu', value: 'Menu' }, { label: 'Subscription Menu', value: 'Subscription Menu' }]
  const mealTypeButtons = [];
  if (regularMenuAvailable) {
    mealTypeButtons.push({ label: 'Regular Menu', value: 'Menu' });
  }
  if (subscriptionMenuAvailable) {
    mealTypeButtons.push({ label: 'Combo Menu', value: 'Combo Menu' });
  }

  const Mapping = { Menu: 'NonMealItems', 'Combo Menu': 'MealItems' };
  const ProductListObject =
    productsData?.data?.categorizedProducts?.[urlStoreName]?.[Mapping[mealType]];
  const custActStatus =
    custInfoData?.user_Info?.reason_status === 'Active' ||
    custInfoData?.user_Info?.reason_status === 'Customer unsubscribed';
  const custMealPlan = custInfoData?.meal_Package?.meal_plan;
  const custActType = custInfoData?.user_Info?.account_type === 'Subscription';
  const custErrorUser = errorMessage === 'User does not exist'; // Logot User and ask to login again
  const custAdminInactive = errorMessage === 'Account is blocked by Administration';
  const zeroPlatesAvailable = custInfoData?.available_plates === 0; // Chck with kuldeep
  const disableProductView = !isLoggedIn || !custActType || zeroPlatesAvailable;

  const handleMealType = (x) => {
    setMealType(x.value);
    setActiveTab(menuTabNames[x.value]?.[0] || '');
    scrollToTop();
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    scrollToTop();
  }, []);

  useEffect(() => {
    if (productsData.data && urlStoreName) {
      if (
        productsData?.data?.categorizedProducts &&
        productsData?.data?.categorizedProducts?.[urlStoreName]
      ) {
        setMenuTabNames({
          ...menuTabNames,
          Menu:
            Object.keys(
              productsData?.data?.categorizedProducts?.[urlStoreName]?.NonMealItems || {}
            ) || [],
          'Combo Menu':
            Object.keys(
              productsData?.data?.categorizedProducts?.[urlStoreName]?.MealItems || {}
            ).filter((key) => {
              const allowedProducts = getMealOffering()[key];
              if (!allowedProducts) {
                return false;
              }
              return true;
            }) || [],
        });

        setActiveTab(
          (Object.keys(
            productsData?.data?.categorizedProducts?.[urlStoreName]?.NonMealItems || {}
          ) || [])[0] || ''
        );
      }
    }
  }, [productsData]);
  return (
    <>
      <Storetitle mealType={mealType} />
      <div
        style={{
          position: 'sticky',
          top: '62px',
          backgroundColor: 'white',
          zIndex: '1',
          boxShadow: '0 3px 3px -1px rgba(0,0,0,.2)',
          marginBottom: '10px',
          height: '110px',
        }}
      >
        {mealTypeButtons.map((el, index) => {
          return (
            <button
              key={`${el.menu}_${index}`}
              className={`button-ipad meal-type-button ${mealType === el.value ? 'active-button-desktop' : 'inactive-button-desktop'}`}
              onClick={() => {
                handleMealType(el);
              }}
            >
              <div className='meal-type-button-content'>
                <div className='meal-type-button-label'>{el.label}</div>
                {(deliveryPayAsYouGo_fee > 0 || deliverySubscription_fee > 0) && (
                  <div className='meal-type-button-subcontent'>
                    {el.value !== 'Combo Menu'
                      ? deliveryPayAsYouGo_fee > 0
                        ? `$${deliveryPayAsYouGo_fee} Delivery | 20-40 min`
                        : null
                      : deliverySubscription_fee > 0 && freeSubscriptionDelivery
                        ? `$${deliverySubscription_fee} Delivery Now | Free NextDay`
                        : deliverySubscription_fee > 0
                          ? `$${deliverySubscription_fee} Delivery Now`
                          : ''}
                  </div>
                )}
              </div>
            </button>
          );
        })}

        <div>
          {menuTabNames[mealType]?.length > 0 && (
            <MenuTabs tabNames={menuTabNames[mealType]} value={activeTab} setValue={setActiveTab} />
          )}
        </div>
      </div>
      <div className='product-ipad-container'>
        {/*{mealType === 'Combo Menu' && disableProductView && <div style={{
                    width: '98%',
                    height: '100%',
                    position: 'absolute',
                    // background: 'rgb(0,0,0,0.2)',
                    background: 'rgb(0, 0, 0 ,0.2)',
                    // opacity: '0.8',
                    border: '1px solid #181436',
                    borderRadius: '5px',
                    display: 'flex',
                    // justifyContent: 'center', 
                    // alignItems: 'top'
                    zIndex: 2,
                    top: 0
                }}>
                    <div className='product-login-popup-ipad'>
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                            <div>
                                <InsertEmoticonIcon sx={{ color: '#181436', fontSize: '40px' }} />
                            </div>
                            <div style={{

                                fontFamily: 'Roboto Medium', fontSize: '18px',
                                letterSpacing: '0.5px', margin: '0px 0px 0px 10px',
                                transform: 'translateZ(45px)'
                            }}>
                                {ButtonSwitchSubscription()?.verbiage}
                            </div>
                        </div>

                        <AtomicButton
                            label={ButtonSwitchSubscription()?.buttonLabel}
                            loading={false}
                            style={{ height: '30px', width: '50%' }}
                            handleSubmit={ButtonSwitchSubscription()?.handleMethod}
                        />
                    </div>

                </div>} */}

        {mealType === 'Menu' &&
          Object.keys(ProductListObject || {}).map((el) => {
            return (
              <div className='product-card-list' id={el} key={el}>
                <div
                  style={{
                    color: 'black',
                    fontFamily: 'Roboto Bold',
                    fontSize: '16px',
                    margin: '10px',
                    paddingLeft: '5px',
                    textTransform: 'capitalize',
                  }}
                >
                  {TextTransformation(el)}
                </div>
                <div style={{ display: 'flex', flexWrap: 'wrap', zIndex: '0' }}>
                  {ProductListObject[el] &&
                    ProductListObject[el].map((product) => (
                      <div key={product.product_name}>
                        <ProductCard product={product} mealType={mealType}></ProductCard>
                      </div>
                    ))}
                </div>
              </div>
            );
          })}

        {mealType === 'Combo Menu' && (
          <ProductVerticalStepper ProductListObject={ProductListObject} mealType={mealType} />
        )}
      </div>
    </>
  );
};

export default RestaurantMenuIpad;
